<script setup lang="ts">
// 1:1 port of the styleguide `kgr-modal-content` — a pure class carrier (@HostBinding only).
// Defaults are the ORIGINAL's: `withPadding` and `scrollable` are both true there
// (modal-content.component.ts:14-26), so a call site that must not scroll says so explicitly.
withDefaults(defineProps<{ withPadding?: boolean, small?: boolean, scrollable?: boolean }>(), {
    withPadding: true,
    small: false,
    scrollable: true,
});
</script>

<template>
    <div
        class="kgr-modal__content"
        :class="{
            'kgr-region': withPadding,
            'kgr-region--small': small,
            'kgr-modal__content--scrollable kgr-scrollable': scrollable,
        }"
    >
        <slot></slot>
    </div>
</template>
